module.exports = __webpack_public_path__ + "img/google-my-business-logo.466569d2.svg";